const AUTHENTICATION_KEY = "authentication";
const authTokenSubscribers = new Set();

const readAuthentication = () => {
  const stored = sessionStorage.getItem(AUTHENTICATION_KEY);
  if (!stored || stored === "undefined" || stored === "null") return null;
  try {
    return JSON.parse(stored);
  } catch (error) {
    return null;
  }
};

export const getAuthTokenFromSessionStorage = () =>
  readAuthentication()?.authToken || "";

const publishAuthToken = () => {
  const token = getAuthTokenFromSessionStorage();
  authTokenSubscribers.forEach((listener) => listener(token));
};

export const setAuthenticationInSessionStorage = (authentication) => {
  sessionStorage.setItem(AUTHENTICATION_KEY, JSON.stringify(authentication));
  publishAuthToken();
};

export const removeAuthenticationFromSessionStorage = () => {
  sessionStorage.removeItem(AUTHENTICATION_KEY);
  publishAuthToken();
};

export const subscribeToAuthTokenChanges = (listener) => {
  if (typeof listener !== "function") return () => {};
  const handleStorage = (event) => {
    if (event.key === AUTHENTICATION_KEY || event.key === null) {
      listener(getAuthTokenFromSessionStorage());
    }
  };
  authTokenSubscribers.add(listener);
  window.addEventListener("storage", handleStorage);
  return () => {
    authTokenSubscribers.delete(listener);
    window.removeEventListener("storage", handleStorage);
  };
};
